var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { copyTextToClipboard } from "@frameworks/salesjourney/utils/genericMethods";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import { ERole } from "../Login";
import di from "../di/index";
import { useSelector } from "react-redux";
var ForgotLoginIdSuccess = function (props) {
    var _a, _b;
    var _c = __read(React.useState(false), 2), isIDCopied = _c[0], setIsIDCopied = _c[1];
    var currentLoginComponent = useSelector(function (state) { return state.Login.LoginComponentReducer.reducersData; });
    var handleCopyId = function () {
        var _a, _b;
        copyTextToClipboard((_b = (_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.forgotLoginIdSuccessDetails) === null || _b === void 0 ? void 0 : _b.userId)
            .then(function () {
            setIsIDCopied(true);
            var timeoutId = setTimeout(function () {
                setIsIDCopied(false);
                clearTimeout(timeoutId);
            }, 1500);
        })
            .catch(function (err) {
            console.log(err);
        });
    };
    var handleBackToLogin = function () {
        var _a;
        di.login.changeCurrentLoginComponent({
            currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
            extraConfig: {
                currentActiveTab: ERole.Partner,
                forgotLoginIdSuccessDetails: (_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.forgotLoginIdSuccessDetails,
            },
        });
    };
    return (React.createElement("div", { className: "d-flex flex-column justify-content-start align-items-center w-100 forget-login-id-success-container gap-4" },
        React.createElement("div", { className: "d-flex flex-column gap-3 align-items-center" },
            React.createElement("div", { className: "txt-midnight-blue DMSan_24_700 mb-2" }, "Your Login ID"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, "Copy your login ID and Try Login again"),
            React.createElement("div", { className: "DMSan_24_700 txt_blackOne1" }, (_b = (_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.forgotLoginIdSuccessDetails) === null || _b === void 0 ? void 0 : _b.userId)),
        React.createElement("div", { className: "d-flex align-items-center justify-content-between gap-5" },
            React.createElement("div", { className: "txt-midnight-blue" }, isIDCopied ? (React.createElement("div", { className: "d-flex align-items-center gap-2 DMSans_16_500" },
                React.createElement("i", { className: "edel-icon-green-tick1" }),
                React.createElement("div", null, "Copied!"))) : (React.createElement("div", { onClick: handleCopyId, className: "hand_cursor d-flex align-items-center gap-2 DMSans_16_500" },
                React.createElement("i", { className: "edel-icon-copy-1" }),
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Copy ID" })))),
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back to Login", className: "back-to-login-btn", onClick: handleBackToLogin }))));
};
export default ForgotLoginIdSuccess;
